import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { getProperty } from '../../../modules/ajio-util/properties';
import styles from './index.pcss';
import { getFreebiesText } from './FreebiesCommon';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';

const cx = classNames.bind(styles);

const fallbackImg = `${getProperty('imageBaseUrl')}/static/img/freebie-gift.svg`;
const fallbackImgLuxe = `${getProperty('imageBaseUrl')}/static/img/freebie-gift-luxe.svg`;

const FreebiesGiftCard = (props) => {
    const { giftItemsList = [], halfCardFreebiesTitle='', isDesktop=false, isLuxe=false }= props;
    
    useEffect(() => {
        if (isDesktop) {
            gtmEventPush({
                event: 'pageload',
                page_type: 'Promotion offer screen',
                page_name: 'Promotion offer screen'
            });
        }
    }, []);
    
    return (<div>
        <div className={cx(`${isDesktop ? 'drawer-title-desktop' : 'drawer-title'}`)}>All Promotions</div>
        {giftItemsList.map((item)=>{
            return (<div className={cx(`${isLuxe ? 'freebie-gift-card-luxe': 'freebie-gift-card'}`, `${isDesktop ? "border-radius-desktop": ""}`)}>
                        <div className={cx("pdp-title", `${isLuxe && 'luxe-text-color'}`)}>
                            <img
                                src={isLuxe ? fallbackImgLuxe : fallbackImg}
                                alt="freebie-gift-image"
                                height={"20px"}
                                width={"20px"}
                            />
                            {getFreebiesText(halfCardFreebiesTitle, item?.productDetails?.length)}
                        </div>
                        <div className={!isDesktop ? cx('detailsUrl'): ''}>
                            {item.description} {' '}
                            <div className={cx(`${!isDesktop || isLuxe ? 'detailsUrl' : ''}`, `${isDesktop ? 'a-tag-desktop' : 'a-tag'}`)}><a href={item.detailsUrl}>View all Products</a></div>
                        </div>
                        <div className={cx('t-n-c', `${isDesktop ? 'a-tag-desktop' : 'a-tag'}`)}><a href={item.termsLink}>T&C</a></div>
                        <FreebiesProductsItems
                            products={item.productDetails}
                            isDesktop={isDesktop}
                            isLuxe={isLuxe}
                        />
                    </div>)
            })
        }
    </div>);
};

export const FreebiesProductsItems = ({ products = [], isDesktop=false, isLuxe=false}) => {
    return (
        <>
        {products.map((productItem)=> {
            const { brandName='', name='', selection2AttributeValue='', imageUrl='', uom='', mrp="", quantity=1, isReturnable=false } = productItem;
            return (
            <div className={cx('product-tile', `${isDesktop || isLuxe ? 'border-radius-desktop' : ''}`)}>
                <img 
                    src={imageUrl ? imageUrl : isLuxe ? fallbackImgLuxe :fallbackImg} 
                    alt="product-image"
                    width="56px"
                />
                <div>
                    <div className={cx('product-heading', `${isLuxe && 'luxe-product-text' }`)}>
                {brandName}
                {name && <span>-{name} </span>}
                        {selection2AttributeValue && uom && <span>-{selection2AttributeValue} {uom}</span>}
                    </div>
                    <div className={cx('product-price')}>
                        <div className={cx(`${isLuxe ? 'free-text-luxe' : 'free-text'}`)}>FREE</div>
                        <div>Qty: {quantity}</div>
                    </div>
                    {isReturnable && <div className={cx(`${isLuxe ? 'return-text-luxe' : 'return-text'}`)}>*Needed for Return</div>}
                </div>
            </div>)}
            )}
        </>
    )
};

export default FreebiesGiftCard;
